import { ClearOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, InputNumber, Select, Space } from 'antd'
import { useWatch } from 'antd/es/form/Form'
import { FC, useEffect, useMemo, useRef } from 'react'
import { outputDateFormat } from '../../../../../../../constants/constants'
import { orderRequestStatus } from '../../../../../../../constants/entity-enums/order-request-status'
import useFiltersForm from '../../../../../../../hooks/forms/use-filters-form'
import MaterialTypes from '../../../../../../../components/form-items/material-types/material-types'
import { useGetMaterialsQuery } from '../../../../../../../store/api/materials-api'

const FiltersForm: FC = () => {
    const { form, onSearch, onClear } = useFiltersForm()
    const materialTypeDocId = useWatch('materialTypeDocId', form)

    const { data: materialsData } = useGetMaterialsQuery({
        ...(materialTypeDocId
            ? { filters: { material_type: { documentId: { $eq: materialTypeDocId } } } }
            : {}),
        fields: ['width', 'documentId'],
        pagination: { pageSize: 1000, page: 1 },
    })

    const widthSelectOptions = useMemo(() => {
        const widths = materialsData?.data.map(item => item.width) || []
        const unique = [...new Set(widths)].sort((a, b) => a - b)

        return unique.map(width => ({ value: width, label: String(width) }))
    }, [materialsData])

    const prevMaterialTypeDocIdRef = useRef<string | undefined>()

    useEffect(() => {
        const prev = prevMaterialTypeDocIdRef.current
        if (prev !== undefined && prev !== materialTypeDocId) {
            form.setFieldsValue({ materialWidth: undefined })
        }
        prevMaterialTypeDocIdRef.current = materialTypeDocId
    }, [materialTypeDocId, form])

    return (
        <Form
            form={form}
            layout={'inline'}
            onFieldsChange={() => {
                onSearch()
            }}
        >
            <Space wrap>
                <Form.Item name={'createdAt'} label={'Дата создания'}>
                    <DatePicker placeholder={'Дата создания'} format={outputDateFormat} />
                </Form.Item>
                <Form.Item name={'requestStatus'} label={'Статус'}>
                    <Select
                        allowClear
                        placeholder={'Статус'}
                        style={{ minWidth: 140 }}
                        popupMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: 200 }}
                        options={orderRequestStatus.map(item => ({ value: item, label: item }))}
                    />
                </Form.Item>
                <Form.Item label={'Тип материала'}>
                    <div style={{ width: 260 }}>
                        <MaterialTypes
                            name={'materialTypeDocId'}
                            rules={[]}
                            noStyle
                            popupMatchSelectWidth={false}
                            dropdownStyle={{ minWidth: 260 }}
                        />
                    </div>
                </Form.Item>
                <Form.Item name={'materialWidth'} label={'Ширина'}>
                    <Select
                        allowClear
                        showSearch
                        placeholder={'Ширина'}
                        style={{ minWidth: 60 }}
                        options={widthSelectOptions}
                        popupMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: 60 }}
                    />
                </Form.Item>
                <Form.Item name={'amount'} label={'Кол-во'}>
                    <InputNumber controls={false} placeholder={'Кол-во'} style={{ width: 60 }} />
                </Form.Item>
                <Form.Item name={'arrivalDate'} label={'Дата прихода'}>
                    <DatePicker placeholder={'Дата прихода'} format={outputDateFormat} />
                </Form.Item>
                <Button icon={<ClearOutlined />} title={'Сбросить фильтры'} onClick={onClear}>
                    Сброс
                </Button>
            </Space>
        </Form>
    )
}

export default FiltersForm
